import { render, staticRenderFns } from "./StaffDepartment.vue?vue&type=template&id=0267baba&"
import script from "./StaffDepartment.vue?vue&type=script&lang=js&"
export * from "./StaffDepartment.vue?vue&type=script&lang=js&"
import style0 from "./StaffDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports